"use strict";
exports.__esModule = true;
exports.CommentBuilderUtils = void 0;
var CommonLibUtils_1 = require("../CommonLibUtils");
var CommentBuilderUtils = /** @class */ (function () {
    function CommentBuilderUtils() {
    }
    /**
     * This method creates html table from the given rows and options
     * @param rows - The rows of the table Array of objects, Headers will be picked from the field names of first row and will be converted to camelCase
     *                Row Field value can be string or object, if object then Object should be of type
     *                    {value: string, color: string, backgroundColor: string, style: Object}
     * @param options - The options for the table
     * @returns The html table
     */
    CommentBuilderUtils.createTable = function (rows, options) {
        if (options === void 0) { options = {}; }
        var header = options.header;
        if (!options.header && !options.noHeader) {
            header = {};
            Object.keys(rows[0]).forEach(function (key) {
                header[key] = {
                    label: CommonLibUtils_1.CommonLibUtils.BeautyName(key)
                };
            });
        }
        var strHTML = "\n    <table class=\"bordered-table\" style=\"margin: 0 !important;\">\n    ".concat(header
            ? "\n        <thead>\n            <tr>\n            ".concat(Object.keys(header)
                .map(function (key) { return "<th>".concat(header[key].label, "</th>"); })
                .join(""), "\n            </tr>\n        </thead>\n        ")
            : "", "\n        <tbody>\n        ").concat(rows
            .map(function (row) {
            var isFooter = row === null || row === void 0 ? void 0 : row.Footer;
            return "<tr class=\"".concat(isFooter ? "footer" : "", "\">\n              ").concat(Object.keys(row).filter(function (key) { return key !== "Footer"; })
                .map(function (key) { return "<td>".concat(row[key], "</td>"); })
                .join(""), "\n              </tr>");
        })
            .join(""), "\n        </tbody>\n    </table>\n    ");
        return strHTML;
    };
    return CommentBuilderUtils;
}());
exports.CommentBuilderUtils = CommentBuilderUtils;
//# sourceMappingURL=CommentBuilderUtils.js.map